(function () {
  if (window.__hfbProductShipping) return;
  window.__hfbProductShipping = true;

  var THRESHOLD = 4500;
  var DAY_NAMES = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addBusinessDays(start, count) {
    var date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var added = 0;
    while (added < count) {
      date.setDate(date.getDate() + 1);
      var weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
    }
    return date;
  }

  function formatCardDate(date) {
    return DAY_NAMES[date.getDay()] + ', ' + MONTHS[date.getMonth()] + ' ' + date.getDate();
  }

  function formatRange(start, end) {
    if (start.getMonth() === end.getMonth()) {
      return MONTHS[start.getMonth()] + ' ' + start.getDate() + '-' + end.getDate();
    }
    return MONTHS[start.getMonth()] + ' ' + start.getDate() + ' - ' + MONTHS[end.getMonth()] + ' ' + end.getDate();
  }

  function deliveryDates() {
    var now = new Date();
    var twoDays = addBusinessDays(now, 2);
    var threeDays = addBusinessDays(now, 3);
    return {
      by: formatCardDate(threeDays),
      range: formatRange(twoDays, threeDays),
    };
  }

  function fillDates(root, dates) {
    root.querySelectorAll('[data-shipping-date]').forEach(function (el) {
      el.textContent = dates.by;
    });
    root.querySelectorAll('[data-shipping-range]').forEach(function (el) {
      el.textContent = dates.range;
    });
  }

  function initAll() {
    var dates = deliveryDates();
    document.querySelectorAll('[data-product-shipping]').forEach(function (root) {
      fillDates(root, dates);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('globoFilterRenderCompleted', initAll);
  document.addEventListener('productAdded', initAll);
})();
